import React, {useEffect, useState} from 'react';
import {useFormik} from 'formik';
import Ebutton from '../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import _ from 'lodash';
import {connect} from 'react-redux';
import actions from '../../redux/actions';
import './ChangePass.scss';
import {useHistory} from 'react-router-dom';
import ArrowBackComponent from '../../common/components/ArrowBack/ArrowBack';
import CustomInput from '../../common/components/CustomInput/CustomInput';

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const _ChangePassword = (props) => {
    const {
        putChangePasswordRequest,
        putChangePasswordState,
        resetChangePasswordState,
        showSidebar,
    } = props;

    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);



    useEffect(() => {
        if (putChangePasswordState.success) {
            setTimeout(() => {
                resetChangePasswordState(); // Nueva acción para reiniciar el estado
                history.push('/config');
            }, 3000);
        }
    }, [putChangePasswordState.success]);


    const validationSchema = yup.object({
        newPassword: yup
            .string('Ingrese nueva contraseña')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*["#@$!%*?&._+=-])[A-Za-z0-9\\d"#@$!%*?&._+=-]{8,}$/,
                'Debe tener 8 caracteres, con minúscula, mayúscula, numero y caracter especial',
            )
            .required('Ingrese nueva contraseña'),
        oldPassword: yup
            .string('Ingrese contraseña')
            .required('Ingrese contraseña'),
    });
    const history = useHistory();

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const body = {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            };

            try {
                await putChangePasswordRequest(body);
            } catch (error) {
                console.error('Error changing password:', error);
            }
        },
    });

    const handleArrowBack = () => {
        history.goBack();
    };
    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}
        style={{backgroundColor: 'transparent', margin: '10px', padding: '10px'}}>
            <div className="v2-pass-inner-container">

            <div className="ul-div-sect-header" style={{justifyContent: 'start', marginBottom: '40px'}}>
                <div style={{width: '40px', height: '40px', marginRight: '40px'}}>
                            <ArrowBackComponent onClick={handleArrowBack}/>
                </div>
                <p className="h3 v2-c-text-title">Cambiar contraseña</p>
            </div>

                <form className="v2-change-pass-form" onSubmit={formik.handleSubmit}>
                    <div className="v2-pass-form-div-container">
                        <div className="v2-change-pass-input">
                            <CustomInput
                                label={'Contraseña anterior'}
                                type={showPassword ? 'text' : 'password'}
                                /* onChange={formik.handleChange}*/
                                value={formik.values.oldPassword}
                                placeholder={'*******'}
                                onChange={(value) => formik.setFieldValue('oldPassword', value)}
                            />
                        </div>

                        <div className="v2-change-pass-input">
                            <CustomInput
                                label={'Nueva contraseña'}
                                type={showRePassword ? 'text' : 'password'}
                                /* onChange={formik.handleChange}*/
                                value={formik.values.newPassword}
                                placeholder={'*******'}
                                onChange={(value) => formik.setFieldValue('newPassword', value)}
                            />
                            <div className="eu-div-input justify-center">
                                <InputErrorMessage formik={formik} name='newPassword' className='rp-input-l'/>
                            </div>
                        </div>

                    </div>
                    <div className={'v2-submit-pass-button-container'}>
                        {/* padding should be 16h x 24w*/}
                        <Ebutton classNameButton="v2-submit-pass-button" type="submit" text="Cambiar"/>
                    </div>

                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    showSidebar: state.common.showSidebar,
    putChangePasswordState: state.home.putChangePasswordState,
});

const mapDispatchToProps = (dispatch) => ({
    putChangePasswordRequest: (body) => dispatch( actions.home.putChangePasswordRequest(body) ),
    resetChangePasswordState: () => dispatch( actions.home.resetChangePasswordState()),
});


export default connect(mapStateToProps, mapDispatchToProps)(_ChangePassword);
